import { render, staticRenderFns } from "./service-bills.vue?vue&type=template&id=3c7ad18a&scoped=true&"
import script from "./service-bills.vue?vue&type=script&lang=js&"
export * from "./service-bills.vue?vue&type=script&lang=js&"
import style0 from "./service-bills.vue?vue&type=style&index=0&id=3c7ad18a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ad18a",
  null
  
)

export default component.exports